<template>
    <div class="accordion__container cursor-pointer" :class="{open: open}">
        <div
            class="accordion__header cursor-pointer d-flex flex-row justify-content-start align-items-start"
            @click="$emit('openChange', !open)"
        >
            <h3>{{ title }} ({{ bookTitle }})</h3>
            <button class="accordion__close bg-transparent border-0 p-0 m-0 ml-auto" type="button">
                <span class="icon-close"></span>
            </button>
        </div>

        <p class="mb-0">
            {{ bookAuthor }}
        </p>
        <p class="mb-0">
            {{ language }}
        </p>
        <p>
            {{ publisher }} ({{ year }})
        </p>

        <transition
            :css="false"
            @before-enter="beforeOpen"
            @enter="onOpen"
            @leave="onClose"
        >
            <div v-if="open" class="overflow-hidden">
                <hr/>
                <table>
                    <tr v-for="(info, index) in infoList" :key="index">
                        <td class="pr-2">{{ info.name }}</td>
                        <td class="pl-2 font-weight-bold">{{ info.value }}</td>
                    </tr>
                </table>
            </div>
        </transition>
    </div>
</template>

<script>

const head = arr => arr[0];
const tail = arr => arr.slice(1);

function get (obj, path) {
    function innerGet (obj, path) {
        if (!obj) return '';
        if (path.length === 0) return obj;
        const prop = head(path);
        return innerGet(obj[prop], tail(path));
    }

    return innerGet(obj, path.split('.'));
}

export default {
    props: {
        book: {
            type: Object,
            required: true,
        },
        open: {
            type: Boolean,
        },
    },
    computed: {
        bookAuthor () {
            return get(this.book, 'book.author.firstName') + ' ' + get(this.book, 'book.author.lastName');
        },
        bookGenre () {
            return get(this.book, 'book.genre');
        },
        bookPublisher () {
            return get(this.book, 'book.publisher.name');
        },
        bookYear () {
            return get(this.book, 'book.releaseYear');
        },
        bookTitle () {
            return get(this.book, 'book.title');
        },
        isbn () {
            return this.book.isbn || '';
        },
        language () {
            return get(this.book, 'language.name');
        },
        publisher () {
            return get(this.book, 'publisher.name');
        },
        year () {
            return get(this.book, 'releaseYear');
        },
        title () {
            return get(this.book, 'title');
        },
        translator () {
            return get(this.book, 'translator.name');
        },
        infoList () {
            return [
                { name: 'Author', value: this.bookAuthor },
                { name: 'Translated title', value: this.title },
                { name: 'Genre', value: this.bookGenre.name },
                { name: 'Language', value: this.language },
                { name: 'Translated by', value: this.translator },
                { name: 'Foreign publisher', value: this.publisher },
                { name: 'Translation year', value: this.year },
                { name: 'Original title', value: this.bookTitle },
                { name: 'Danish publisher', value: this.bookPublisher },
                { name: 'Publication year', value: this.bookYear },
                { name: 'ISBN', value: this.isbn },
            ];
        },
    },
    methods: {
        beforeOpen: function (el) {
            jQuery(el).css('height', '0px');
        },
        onOpen: function (el, done) {
            jQuery(el).animate({ height: el.scrollHeight }, 400, done);
        },
        onClose: function (el, done) {
            jQuery(el).animate({ height: 0 }, 400, done);
        },
    },
};
</script>
